import { createElement } from 'react';
import { useDispatch } from 'react-redux';
import { app, user } from 'core';
import { Icon, HeaderStyles as Header, HeaderMenu, Logout } from 'ui/components';
import { HeaderSearch, HeaderCart, HeaderLogo, Cycle, HeaderNavBar } from './widgets';
import { useLogout } from './hooks';
import { actions } from 'core/use-cases/app';

const HeaderMobile = () => {
  const { handleLogout } = useLogout();

  const dispatch = useDispatch();
  const isMenuActive: boolean = app.hooks.useApp('isMobileMenuActive');
  const openMenu = () => dispatch(actions.toggleMenu(true));
  const closeMenu = () => dispatch(actions.toggleMenu(false));
  const {
    data: { isBlocked: isUserBlocked },
  } = user.hooks.useUser();

  return (
    <>
      <Header.Component data-fixed={true} data-testid="header-mobile">
        <Header.Container aria-labelledby="menu-nav" data-justify="space-between">
          <HeaderMenu onClick={openMenu} open={isMenuActive}>
            Menu
          </HeaderMenu>

          <HeaderLogo />

          <HeaderCart />
        </Header.Container>

        <Header.Divider data-divider={true} />

        {!isUserBlocked && (
          <Header.Container aria-labelledby="sub-header" data-justify="space-between">
            <HeaderSearch />
          </Header.Container>
        )}
      </Header.Component>

      <Header.Space data-small={isUserBlocked} />

      <Header.Overlay onClick={closeMenu} visible={isMenuActive} />
      <Header.Drawer data-open={isMenuActive}>
        <Header.Close onClick={closeMenu} data-show={isMenuActive}>
          {createElement(Icon['Close'], { size: 'm' })}
        </Header.Close>

        <Header.Wrapper>
          {!isUserBlocked && (
            <>
              <Cycle />
              <Header.Divider />
            </>
          )}

          <Header.NavBar data-justify="right">
            <HeaderNavBar />

            <Header.Logout>
              <Logout onClick={handleLogout} />
            </Header.Logout>
          </Header.NavBar>
        </Header.Wrapper>
      </Header.Drawer>
    </>
  );
};

export default HeaderMobile;
